export default __webpack_public_path__ + "static/media/circle (1).8475e4f9.svg";